export enum TABLE_ACTIONS {
  EDIT,
  DELETE,
  EDIT_POPUP_CONFIRM,
  EDIT_POPUP_CANCEL,  
  DELETE_POPUP_CONFIRM,
  DELETE_POPUP_CANCEL,
}